import { useEffect } from 'react';

// Public share/feedback pages live behind unguessable URLs; keep search
// engines from indexing them. The SPA serves one index.html for every route,
// so the directive has to be injected at runtime rather than in static HTML.
export const useNoIndexMeta = () => {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
};
